/* ==========================================================================
   The Common Guild — Horizon add-on script
   Replaces the old 295 KB script.js bundle (jQuery, Swipebox and Graphical
   House's original site code). Horizon handles search, account and basket;
   this file only adds:
     1. Mobile menu (burger) and moving the currency selector into it
     2. Header height variables Horizon expects
     3. Roundel resting above the footer
   No dependencies. Re-initialises when sections reload in the theme editor.
   ========================================================================== */

(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 1000px)';

  /* ------------------------------------------------------------------------
     1 & 2. Header
     ------------------------------------------------------------------------ */

  function initHeader(root) {
    var header = (root || document).querySelector('[data-tcg-header]');
    if (!header || header.dataset.tcgReady) return;
    header.dataset.tcgReady = 'true';

    var burger = header.querySelector('[data-tcg-burger]');
    var menu = header.querySelector('[data-tcg-menu]');
    var mobile = window.matchMedia(MOBILE_QUERY);

    function setOpen(open) {
      header.classList.toggle('is-menu-open', open);
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    if (burger && menu) {
      burger.addEventListener('click', function () {
        setOpen(!header.classList.contains('is-menu-open'));
      });

      header.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && header.classList.contains('is-menu-open')) {
          setOpen(false);
          burger.focus();
        }
      });
    }

    // Horizon's currency selector is rendered once. On small screens it sits
    // in the mobile menu rather than the crowded header bar.
    var localization = header.querySelector('[data-tcg-localization]');
    var desktopSlot = header.querySelector('[data-tcg-localization-desktop]');
    var mobileSlot = header.querySelector('[data-tcg-localization-mobile]');

    function placeLocalization() {
      if (!localization || !desktopSlot || !mobileSlot) return;
      var target = mobile.matches ? mobileSlot : desktopSlot;
      if (localization.parentElement !== target) target.appendChild(localization);
    }

    function onBreakpointChange() {
      if (!mobile.matches) setOpen(false);
      placeLocalization();
    }

    placeLocalization();
    if (mobile.addEventListener) mobile.addEventListener('change', onBreakpointChange);

    // Horizon positions some elements (sticky product details, full-height
    // banners, the account pop-up) using --header-height and
    // --header-group-height. Horizon's own header normally sets these.
    var section = header.closest('.shopify-section') || header;
    var stickyMode = header.dataset.sticky;
    var wide = window.matchMedia('(min-width: 901px)');

    function updateHeights() {
      var height = section.offsetHeight;
      var isSticky = stickyMode === 'always' || (stickyMode === 'desktop' && wide.matches);
      document.body.style.setProperty('--header-height', (isSticky ? height : 0) + 'px');
      document.body.style.setProperty('--header-group-height', height + 'px');
    }

    updateHeights();
    if ('ResizeObserver' in window) new ResizeObserver(updateHeights).observe(section);
    if (wide.addEventListener) wide.addEventListener('change', updateHeights);
  }

  /* ------------------------------------------------------------------------
     3. Roundel
     Fixed to the bottom right, then stops just above the footer. The old
     theme did this with a scroll listener; an IntersectionObserver does the
     same without running on every scroll event (Horizon scrolls an inner
     element on desktop, which the old approach would not detect).
     ------------------------------------------------------------------------ */

  function initRoundel(root) {
    var anchor = (root || document).querySelector('[data-tcg-roundel-anchor]');
    if (!anchor || anchor.dataset.tcgReady) return;
    anchor.dataset.tcgReady = 'true';

    var roundel = anchor.querySelector('[data-tcg-roundel]');
    if (!roundel || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      // Park once the footer line has entered the viewport or scrolled past it.
      var parked = entry.isIntersecting || entry.boundingClientRect.top < 0;
      roundel.classList.toggle('is-parked', parked);
    }).observe(anchor);
  }

  /* ------------------------------------------------------------------------
     Init
     ------------------------------------------------------------------------ */

  function init(root) {
    initHeader(root);
    initRoundel(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: sections are re-rendered when settings change.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
